import { r as registerInstance, c as createEvent, h, g as getElement } from './index-16dc7dde.js';
import { z as PesLinkEnum } from './request.constants-deb285e0.js';
import { y as isBrowser } from './utils-15ad90ec.js';
import './send-33ade633.js';
import './analytics-765d4daf.js';
import './utils-913bdf8a.js';
import './lookups-705fb53e.js';
import './_commonjsHelpers-ba3f0406.js';
import './tslib.es6-2af8cb53.js';
import './_isIndex-af307327.js';
import './toNumber-5000b45d.js';
import './isObject-33fa1780.js';
import './isSymbol-45bfef0c.js';
import './currency-b61904e0.js';
import './parsers-e38ff6a5.js';

const linkCss = ":host{display:inline;box-sizing:border-box;font-size:14px;line-height:1.4285714286}:host *,:host *::before,:host *::after{box-sizing:inherit}.link{background:none;color:#42b4e6;border:none;padding:0;cursor:pointer;outline:inherit;font-family:inherit;text-decoration:none;font-size:inherit;line-height:inherit}.link:hover{text-decoration:underline}.link:hover{text-decoration:none}.link *{vertical-align:middle}:host(:not([dir=\"rtl\"])) .link__icon{margin-right:4px}:host([dir=\"rtl\"]) .link__icon{margin-left:4px}.link:hover .link__text{text-decoration:underline}";

let Link = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didClickPDPLink = createEvent(this, "didClickPDPLink", 7);
    this.iconSize = 'small';
    this.target = '_self';
    this.displayType = PesLinkEnum.link;
    this.handleClick = (e) => {
      this.didClickPDPLink.emit({ nativeEvent: e });
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    if (this.displayType === PesLinkEnum.button) {
      return (h("button", { type: "button", class: "link", onClick: this.handleClick }, this.icon && isBrowser() && (h("pes-icon", { class: "link__icon", size: this.iconSize }, this.icon)), h("span", { class: "link__text", innerHTML: this.label })));
    }
    return (h("a", { class: "link", href: this.link, target: this.target, onClick: this.handleClick }, this.icon && isBrowser() && (h("pes-icon", { class: "link__icon", size: this.iconSize }, this.icon)), h("span", { class: "link__text", innerHTML: this.label })));
  }
  get el() { return getElement(this); }
};
Link.style = linkCss;

export { Link as pes_link };
